import React, { Component } from 'react';
import PropTypes from "prop-types";
import { Icon } from "antd";
export default class Menu extends Component {
  state = {
    activeKey: 1,
  }
  static propTypes = {
    menus: PropTypes.array.isRequired,
  };
  componentDidMount() {
    const { menus } = this.props;
    //路由绑定
    let pathname = this.props.history.location.pathname;
    let path = pathname.split('/')[2];

    if (!path) return;
    for (let i = 0; i < menus.length; i++) {
      const item = menus[i];
      for (let j = 0; j < item.subMenus.length; j++) {
        const it = item.subMenus[j];
        if (it.url.includes(path)) {
          this.setState({
            activeKey: it.key,
          })
        }
      }
    }
    //路由监听
    this.props.history.listen((res) => {
      let path = res.pathname.split('/')[2];
      if (!path) return;
      for (let i = 0; i < menus.length; i++) {
        const item = menus[i];
        for (let j = 0; j < item.subMenus.length; j++) {
          const it = item.subMenus[j];
          if (it.url.includes(path)) {
            this.setState({
              activeKey: it.key,
            })
          }
        }
      }
    })

  }
  onMenuChange(activeKey, url) {
    this.props.history.push("/center" + url);
    this.setState({
      activeKey,
    })
  }
  render() {
    const { menus } = this.props;
    const { activeKey } = this.state;
    return (
      <div className="center-menu">
        <ul>
          {
            menus.map((item, i) => (
              <li key={`menu${i}`} className="menu">
                {
                  item.Name && <h1>{item.Name}</h1>
                }
                <ul>
                  {
                    item.subMenus.map((it, key) => (
                      <li key={`submenu${key}`} className={it.key === activeKey ? "submenu-active" : `submenu ${it.Name === "课程管理" ? "step3" : it.Name === "做题记录" ? "step4" : it.Name === "账号中心" ? "step5" : ""}`} onClick={this.onMenuChange.bind(this, it.key, it.url)}>
                        <Icon type={it.Icon} />{it.Name}
                      </li>
                    ))
                  }
                </ul>
              </li>))
          }
        </ul>
      </div>
    );
  }
} 



// WEBPACK FOOTER //
// ./src/features/center/Menu.js